import IUser from 'domains/users/models/IUser'

export const getFullName = (user: IUser) => `${user.firstName} ${user.lastName}`
